import { render, staticRenderFns } from "./CleanerStatus.vue?vue&type=template&id=872fc49e&scoped=true"
import script from "./CleanerStatus.vue?vue&type=script&lang=js"
export * from "./CleanerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872fc49e",
  null
  
)

export default component.exports